document.addEventListener('click', (event) => {
  const button = event.target.closest('.qty-dropdown__button');
  const option = event.target.closest('.qty-dropdown__option');

  const closeOpenMenus = () => {
    document.querySelectorAll('.qty-dropdown__menu.is-open').forEach((menu) => {
      menu.classList.remove('is-open');
      menu.closest('.qty-dropdown')?.classList.remove('is-open');
    });
  };

  if (button) {
    const dropdown = button.closest('.qty-dropdown');
    if (!dropdown) return;
    if (button.disabled || dropdown.classList.contains('is-disabled')) return;

    const menu = dropdown.querySelector('.qty-dropdown__menu');
    if (!menu) return;

    event.stopPropagation();

    const isOpen = menu.classList.contains('is-open');
    closeOpenMenus();

    menu.classList.toggle('is-open', !isOpen);
    dropdown.classList.toggle('is-open', !isOpen);
    return;
  }

  if (option) {
    const dropdown = option.closest('.qty-dropdown');
    if (dropdown?.classList.contains('is-disabled')) return;
    const menu = dropdown?.querySelector('.qty-dropdown__menu');
    const buttonEl = dropdown?.querySelector('.qty-dropdown__button');
    const select = dropdown?.querySelector('.qty-dropdown__select');
    const label = dropdown?.querySelector('.qty-dropdown__label');
    if (!dropdown || !menu || !buttonEl || !select || !label) return;

    const value = option.dataset.value;
    label.textContent = value;
    select.value = value;
    menu.querySelectorAll('.qty-dropdown__option').forEach((menuOption) => {
      menuOption.classList.remove('is-selected');
    });
    option.classList.add('is-selected');
    menu.classList.remove('is-open');
    dropdown.classList.remove('is-open');
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  closeOpenMenus();
});
